import ApiService from '@/services/api.service'

export async function getAllGenres(){
    let response = await ApiService.get("genre/all");
    return response.data;
}